import { useState, useCallback } from 'react';
import * as transportOrderManagementAction from "../../../redux/store-sarang/transport-order/transport-order-management.store";
import * as cuisineOrderManagementAction from "../../../redux/store-sarang/cuisine-order/cuisine-order-management.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";

export const useTransportOrderActions = ({
    showLoading,
    getListTransportOrderManagement,
    page,
    rowsPerPage,
    orderBy,
    order,
    searchData,
    deviceId,
    currentUser,
    buttonOpenAddEditRef,
    buttonOpenConfirmRef,
    buttonOpenConfirmCreateCuisineRef
}) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [isOpenAddEditDialog, setOpenAddEditDialog] = useState(false);
    const [isOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [isOpenDeactiveDialog, setOpenDeactiveDialog] = useState(false);
    const [isOpenChangeStatusDialog, setOpenChangeStatusDialog] = useState(false);
    const [isOpenAssignToMeDialog, setOpenAssignToMeDialog] = useState(false);
    const [isOpenCreateCusineDialog, setOpenCreateCusineDialog] = useState(false);
    const [isOpenAssignDeliveryDialog, setOpenAssignDeliveryDialog] = useState(false);
    const [isOpenCancelDeliveryDialog, setOpenCancelDeliveryDialog] = useState(false);

    const openChangeDeliveryDialog = (item) => {
        setOpenAddEditDialog(true);
        setSelectedItem(item);
        buttonOpenAddEditRef.current.click();
    };

    const closeAddEditDialog = () => {
        setOpenAddEditDialog(false);
        setSelectedItem(null);
    };

    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        buttonOpenConfirmRef.current.click();
    };

    const openConfirmCreateCuisineDialog = (item) => {
        setSelectedItem(item);
        buttonOpenConfirmCreateCuisineRef.current.click();
    };

    const closeConfirmDialog = () => {
        if (!isOpenAssignToMeDialog && !isOpenAssignDeliveryDialog) {
            setOpenCreateCusineDialog(false);
            setSelectedItem(null);
        }
        setOpenDeleteDialog(false);
        setOpenActiveDialog(false);
        setOpenDeactiveDialog(false);
        setOpenChangeStatusDialog(false);
        setOpenAssignToMeDialog(false);
        setOpenAssignDeliveryDialog(false);
        setOpenCancelDeliveryDialog(false);
    };

    const closeConfirmCreateCuisineDialog = async () => {
        setOpenAssignToMeDialog(false);
        setOpenAssignDeliveryDialog(false);
        setOpenCreateCusineDialog(false);

        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
    };

    const assignDelivery = async (createCuisine) => {
        const res = await transportOrderManagementAction.AssignDeliver({
            deviceId: deviceId,
            transportOrderId: selectedItem.id,
            herdsmanDeliverId: selectedItem.herdsmanDeliverId,
            createCuisineForShipper: createCuisine,
        });

        if (res) {
            const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
            getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
        }

        return res;
    };

    const handleConfirm = async () => {
        try {
            let res = null;
            if (isOpenDeleteDialog) {
                res = await transportOrderManagementAction.DeleteTransportOrder(selectedItem.id);
            } else if (isOpenActiveDialog) {
                res = await transportOrderManagementAction.ActiveTransportOrder(selectedItem.id);
            } else if (isOpenDeactiveDialog) {
                res = await transportOrderManagementAction.DeActiveTransportOrder(selectedItem.id);
            } else if (isOpenChangeStatusDialog) {
                res = await transportOrderManagementAction.ChangeTransportOrderStatus({
                    id: selectedItem.id,
                    status: selectedItem.orderStatusChange
                });
            } else if (isOpenCancelDeliveryDialog) {
                res = await transportOrderManagementAction.ClearDelivery(selectedItem.cuisineOrderID, deviceId);
            } else if (isOpenAssignToMeDialog || isOpenAssignDeliveryDialog) {
                const result = await cuisineOrderManagementAction.CheckExistsCuisine(selectedItem.herdsmanDeliverId, selectedItem.orderDate, selectedItem.receiptTime);
                if (result && result.content) {
                    res = await transportOrderManagementAction.AssignDeliver({
                        transportOrderId: selectedItem.id,
                        herdsmanDeliverId: isOpenAssignToMeDialog ? currentUser.herdsmanId : selectedItem.herdsmanDeliverId,
                        createCuisineForShipper: false,
                        deviceId: deviceId
                    });
                } else {
                    setOpenCreateCusineDialog(true);
                    openConfirmCreateCuisineDialog(selectedItem);
                    return;
                }
            }

            if (res) {
                const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
                getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
            }

            showLoading(false);
            closeConfirmDialog();
        } catch (err) {
            showLoading(false);
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        }
    };

    const handleSubmitChangeDelivery = async (data) => {
        showLoading(true);
        try {
            const res = await transportOrderManagementAction.ChangeDeliver(data);
            if (res && res.content) {
                const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
                getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
            }
        } catch (err) {
            showLoading(false);
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        }
    };

    return {
        selectedItem, setSelectedItem,
        isOpenAddEditDialog, setOpenAddEditDialog,
        isOpenDeleteDialog, setOpenDeleteDialog,
        isOpenActiveDialog, setOpenActiveDialog,
        isOpenDeactiveDialog, setOpenDeactiveDialog,
        isOpenChangeStatusDialog, setOpenChangeStatusDialog,
        isOpenAssignToMeDialog, setOpenAssignToMeDialog,
        isOpenCreateCusineDialog, setOpenCreateCusineDialog,
        isOpenAssignDeliveryDialog, setOpenAssignDeliveryDialog,
        isOpenCancelDeliveryDialog, setOpenCancelDeliveryDialog,
        openChangeDeliveryDialog,
        closeAddEditDialog,
        openConfirmDialog,
        openConfirmCreateCuisineDialog,
        closeConfirmDialog,
        closeConfirmCreateCuisineDialog,
        assignDelivery,
        handleConfirm,
        handleSubmitChangeDelivery
    };
};
